import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import { useClipboard } from '@vueuse/core'
  import UsersApi from '@/services/api/UsersApi'
  import useSegment from '@/composables/useSegment'
  import { UserModule } from '@/store/modules/user'
  import eventBus from '@/main'
  import useI18n from '@/composables/useI18n'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ReferralCodeModal',
  props: {
    referralCode: {
      type: String,
      required: true,
    },
  },
  setup(__props) {

const props = __props;

  

  const { copy, copied } = useClipboard()
  const { referralCandyInviteCodeCopied } = useSegment()
  const { translateString } = useI18n()

  const infoItems = [
    translateString('referrals.copyYourReferralCode'),
    translateString('referrals.recommendUs'),
    translateString('referrals.yourFriendsWillReceive'),
    translateString('referrals.youGet20FromUs'),
  ]

  const copyReferralCode = () => {
    copy(props.referralCode)
    if (copied) {
      referralCandyInviteCodeCopied(UserModule.email, props.referralCode)
      eventBus.$toasted.success(translateString('copied'), { duration: 1000 })
    }
    eventBus.$emit('close-modal')
  }

  onMounted(() => {
    const code = props.referralCode.split('-')
    UsersApi.createReferralCodeInStripe(code[1])
  })

return { __sfc: true,props, copy, copied, referralCandyInviteCodeCopied, translateString, infoItems, copyReferralCode, onMounted, KetchUpButton, useClipboard, UsersApi, useSegment, UserModule, eventBus, useI18n }
}

})